import { useState } from "react";

interface Props {
  scoreId: string;
}

export function ShareLink({ scoreId }: Props) {
  const base = import.meta.env.VITE_SHARE_URL_BASE || window.location.origin;
  const url = `${base}/score/${scoreId}`;
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback: select the text so the user can copy manually
      window.prompt("Copy this share link:", url);
    }
  }

  return (
    <div className="share-link">
      <h3>Share this score</h3>
      <div className="share-link-row">
        <input type="text" readOnly value={url} aria-label="Share URL" />
        <button type="button" onClick={handleCopy}>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
